import React from 'react';
import {ResetPasswordForm} from './ResetPasswordForm';
import {ForgotPasswordForm} from './ForgotPasswordForm';
import {Header} from 'components/header';
import {Alert} from 'components/alert';
import {PasswordService, HelperUtils, CaptchaService} from 'services';
import {TranslationMixin, AlertMixin} from 'mixins';
import {
  WithPasswordTranslations,
  WithCommonTranslations,
  withRouter,
} from 'components/hocs/';

import './ResetPasswordPage.css';

export const ResetPasswordPage = withRouter(
  WithCommonTranslations(
    WithPasswordTranslations(
      class extends AlertMixin(TranslationMixin(React.Component)) {
        constructor(props) {
          super(props);

          this.alertRef = React.createRef();
          this.captchaRef = React.createRef();

          this.state = {
            loading: false,
            alert: {
              display: false,
              type: 'default',
              message: '',
            },
            formValues: {
              username: '',
              email: '',
              newPassword: '',
              confirmPassword: '',
              resetCode: '',
              resetToken: '',
            },
            showForgotPassword: true,
          };

          this.handleBack = this.handleBack.bind(this);
        }

        scrollToAlert() {
          HelperUtils.scrollToAlert(this.alertRef);
        }

        onValidationError = () => {
          this.setState({
            alert: {
              display: true,
              message: this.getTranslation('ERROR_FORM_VALIDATION'),
              type: 'error',
            },
          }, this.scrollToAlert);
        };

        handleChange = (name, value, callback) => {
          this.setState((prevState) => {
            let newState = {};
            let formValues = Object.assign({}, prevState.formValues);
            formValues[name] = value;
            newState.formValues = formValues;
            return newState;
          }, callback);
        };

        handleBack() {
          this.setState({
            showForgotPassword: true,
          });
        }

        handleSubmit = () => {

          this.setState({
            loading: true,
            alert: {
              display: false,
            },
          });

          let opts = null;
          if (this.props.locale) {
            opts = {
              headers: {
                'Accept-Language': this.props.locale.replace('_', '-'),
              },
            };
          }

          if (this.state.showForgotPassword) {
            let captchaData = CaptchaService.getCaptchaData(this.captchaRef);

            if (!captchaData.cText) {
              this.displayAlert(
                this.getTranslation('ERROR_CAPTCHA_MUST_BE_COMPLETED'),
                'error', this.scrollToAlert);
              this.setState({
                loading: false,
              });
              return;
            }

            let {username, email} = this.state.formValues;
            let requestData = Object.assign(
              {username: username, email: email}, captchaData);


            PasswordService.sendEmail(requestData, opts).then((data) => {
              this.clearError();
              this.setState({
                alert: {
                  display: false,
                },
                showForgotPassword: false,
                loading: false,
              });
              this.setState({formValues: data});
            }).catch((error) => {
              this.displayError(error);
              this.setState({
                loading: false,
              });
            });
          } else {
            PasswordService.resetPassword(this.state.formValues.username,
              this.state.formValues.resetCode,
              this.state.formValues.resetToken,
              this.state.formValues.newPassword, opts).then(() => {
              this.setState({
                loading: false,
                alert: {
                  display: true,
                  message: this.getTranslation(
                    'MESSAGE_PASSWORD_CHANGE_SUCCESS'),
                  type: 'success',
                },
              });
              setTimeout(() => {
                this.props.navigate(`/login`);
              }, 700);
            }).catch((error) => {
              this.displayError(error);
              this.setState({
                loading: false,
              });
            });
          }
        };

        render() {
          return (
            <div className="resetPasswordPage">
              <Header level={1}>{this.getTranslation(
                'HEADER_FORGOT_PASSWORD')}</Header>
              <div className="col-sm-12 col-md-6 p-0">{/*Alert Message*/}
                {this.state.alert.display &&
                  <Alert ref={this.alertRef} type={this.state.alert.type}>
                    {this.state.alert.message}
                  </Alert>}
              </div>
              {this.state.showForgotPassword ?
                <ForgotPasswordForm submit={this.handleSubmit}
                                    loading={this.state.loading}
                                    captchaRef={this.captchaRef}
                                    onValidationError={this.onValidationError}
                                    formValues={this.state.formValues}
                                    onChange={this.handleChange}/> :
                <ResetPasswordForm submit={this.handleSubmit}
                                   loading={this.state.loading}
                                   onBack={this.handleBack}
                                   onValidationError={this.onValidationError}
                                   formValues={this.state.formValues}
                                   onChange={this.handleChange}/>}
            </div>
          );
        }
      }))
);
